module.exports = __webpack_public_path__ + "img/download_report.d9e39376.svg";